<template>
  <WdsText class="tw-truncate" :text="date" :data-test="`supplier-since-${rowIndex}`" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const SupplierSinceColumn = graphql(`
  fragment SupplierSinceColumn on SupplierClient {
    id
    createdAt
    companyRecruiter {
      id
      invitedAt
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof SupplierSinceColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(SupplierSinceColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
// A company supplier has no agency relation; the link itself dates it, as the sort does.
const since = computed(() => column.value.companyRecruiter?.invitedAt ?? column.value.createdAt)
const { date } = useDate(since)
</script>
